import * as React from 'react';
import { DateInput } from './Date.jsx';

export const DateTimeInput = ({
  views = ['year', 'month', 'day', 'hours', 'minutes'],
  ...props
}) => {
  return (
    <DateInput
      placeholder='MM/dd/yyyy hh:mm'
      format='MM/dd/yyyy hh:mm a'
      views={views}
      {...props}
    />
  );
};

DateTimeInput.displayName = 'DateTimeInput';

DateTimeInput.propTypes = DateInput.propTypes;
